import api from "@/plugins/api/EntryPoint";

export default {
  getFeedback(callBackFn) {
    api.get(`feedback/get-all-feedback`, callBackFn);
  },
  createTicket(ticket, callBackFn) {
    return api.post(`feedback/add-new-feedback`, ticket, callBackFn);
  },
};
